<template lang="html">
  <div class="main-container" ref="main">
    <div v-for="value in valuesAsList" :key="value.county">
      <div
        :style="{
          width: labelWidth + 'px'
        }"
        class="county-label"
      >
        {{ value.county }}
      </div>
      <div
        :style="{
          width: valueWidth + 'px',
          'margin-left': gutterWidth + 'px'
        }"
        class="county-value"
      >
        {{ getValueLabel(value.value) }}
      </div>
      <div
        :style="{
          width: getWidth(value.value) + 'px',
          'margin-left': gutterWidth + 'px',
          'background-color': getColor(value.value)
        }"
        class="value-bar"
      ></div>
    </div>
  </div>
</template>

<script>
import { max } from "d3-array";
import { getColorMap } from "../utils.js";

export default {
  data: () => ({
    labelWidth: 180,
    valueWidth: 90,
    gutterWidth: 6,
    clientWidth: 0
  }),
  props: {
    values: Object
  },
  mounted() {
    this.clientWidth = this.$refs["main"].clientWidth;
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    maxBarWidth() {
      return (
        this.clientWidth -
        this.labelWidth -
        this.valueWidth -
        2 * this.gutterWidth -
        10
      );
    },
    valuesAsList() {
      return Object.entries(this.values)
        .map(([key, value]) => ({
          county: key,
          value: value
        }))
        .sort((v1, v2) => {
          if (v1.value == v2.value) {
            if (v1.county < v2.county) return -1;
            if (v2.county < v1.county) return 1;
            return 0;
          } else if (isNaN(v1.value)) {
            return 1;
          } else if (isNaN(v2.value)) {
            return -1;
          } else {
            return v2.value - v1.value;
          }
        });
    },
    maxValue() {
      return max(Object.values(this.values));
    },
    colorMap() {
      return getColorMap(this.maxValue);
    },
    normalization() {
      return this.$store.getters.normalization;
    }
  },
  methods: {
    getWidth(v) {
      return this.maxBarWidth * (v / this.maxValue);
    },
    getColor(value) {
      return this.colorMap(value);
    },
    getValueLabel(value) {
      if (isNaN(value)) return "onbekend";
      if (this.normalization == "none" || value == 0) return value;
      return "1 : " + Math.round(1 / value);
    },
    onResize() {
      this.clientWidth = this.$refs["main"].clientWidth;
    }
  }
};
</script>

<style lang="css" scoped>
.main-container {
  margin: 20px;
}
.county-label {
  display: inline-block;
  text-align: right;
  font-size: 1em;
}
.county-value {
  display: inline-block;
  text-align: right;
  font-size: 1em;
}
.value-bar {
  display: inline-block;
  height: 14px;
}
</style>
